
define('known/collections/fantasyTeamCollection',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/fantasyTeamModel'
], function($, _, Backbone, FantasyTeamModel){
	var FantasyTeamCollection = Backbone.Collection.extend({
		model : FantasyTeamModel,
		leagueId : null, //Populate this on construction
		//leagueInstanceId : null, //Populate this on construction
	
		url: function() {
			return '/draftapp/leagues/' + this.leagueId + '/league-instances/' + this.leagueInstanceId.get('id') + '/fantasy-teams';
		},
		
		initialize: function(models, options) {
			this.leagueId = options.leagueId;
			//this.leagueInstanceId = options.leagueInstanceId;
	    },
	    
	    saveChanges: function(successCallback, errorCallback) {
			var dataJson = this.toJSON();
			
			$.ajax({
				headers : {
					"Content-Type" : "application/json",
					"Accept" : "application/json"
				},
				url : 
					'/draftapp/leagues/' 
					+ this.leagueId 
					+ '/league-instances/' 
					+ this.leagueInstanceId.get('id')
					+ '/fantasy-teams',
				type : 'PUT',
				dataType : 'json',
				data : JSON.stringify(dataJson, null, 2),
				success: successCallback,
				error: errorCallback
			});
		}
	});
	
	return FantasyTeamCollection;  
});